(function(){
  if (window.__chpInit) return; window.__chpInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function money(cents, fmt){
    var n = (cents/100).toFixed(2);
    var parts = n.split('.'); var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = whole + '.' + parts[1];
    if (!fmt) return '$' + amount;
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }
  window.chpMoney = money;

  function initRows(root){
    root.querySelectorAll('[data-chp-row]').forEach(function(wrap){
      var row = wrap.querySelector('.chp-row, .chp-tiles'); if (!row) return;
      wrap.querySelectorAll('[data-chp-dir]').forEach(function(btn){
        btn.addEventListener('click', function(){
          row.scrollBy({left: Number(btn.dataset.chpDir) * row.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth'});
        });
      });
    });
  }

  function initCountdowns(root){
    root.querySelectorAll('[data-chp-countdown]').forEach(function(el){
      var end = Date.parse(el.dataset.chpCountdown);
      var host = el.closest('[data-chp-promo]');
      if (isNaN(end)) { if (host) host.hidden = true; return; }
      function tick(){
        var s = Math.floor((end - Date.now())/1000);
        if (s <= 0) { if (host) host.hidden = true; clearInterval(t); return; }
        var d = Math.floor(s/86400), h = Math.floor(s%86400/3600), m = Math.floor(s%3600/60), sec = s%60;
        var p = function(n){ return String(n).padStart(2,'0'); };
        el.innerHTML = (d>0 ? '<span>'+d+'d</span>' : '') + '<span>'+p(h)+'</span>:<span>'+p(m)+'</span>:<span>'+p(sec)+'</span>';
      }
      tick(); var t = setInterval(tick, 1000);
    });
  }

  async function addItems(items){
    var res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})
    });
    var data = await res.json().catch(function(){ return {}; });
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');
    return data;
  }
  window.chpAddItems = addItems;
  window.chpGoToCart = function(){ window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; };

  function initAddons(root){
    root.querySelectorAll('[data-chp-addon]').forEach(function(btn){
      btn.addEventListener('click', async function(){
        btn.disabled = true;
        try { await addItems([{id: Number(btn.dataset.chpAddon), quantity: 1}]); btn.classList.add('is-added'); btn.textContent = btn.dataset.addedLabel || 'Added'; }
        catch(e){ btn.textContent = 'Retry'; }
        btn.disabled = false;
      });
    });
  }

  function run(root){ initRows(root); initCountdowns(root); initAddons(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ run(document); }); else run(document);
  document.addEventListener('shopify:section:load', function(e){ window.__chpRows = true; run(e.target); });
})();
